import React from 'react';

import { Space } from '@mantine/core';
import { IconBuildingSkyscraper } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { ErrorAlert } from 'components/ErrorAlert';
import { FullScreenLoader } from 'components/FullScreenLoader';
import { SettingsSectionWrapper } from 'pages/Settings/SettingTabs/SettingsSectionWrapper';
import { OrganisationUsageSummary } from 'pages/Settings/SettingTabs/UsageSettingsTab/OrganisationUsageSummary';
import { UsageSummary } from 'pages/Settings/SettingTabs/UsageSettingsTab/UsageSummary';
import { useTranslation } from 'react-i18next';
import { OrganisationService } from 'services/organisation-service';
import { UsageService } from 'services/usage-service';
import { UserService } from 'services/user-service';
import { ORGANISATION_USAGE_QUERY_KEY, USER_USAGE_QUERY_KEY } from 'shared/constants/query-keys';
import { UserAccess } from 'shared/interfaces/User';

export function UsageSettingsTab() {
  const { t } = useTranslation();

  const shouldGetOrganisationUsage =
    UserService.isCustomOrganisationMember() && UserService.hasUserAccessWithMinRole(UserAccess.SUPER_ADMIN);

  const usageQuery = useQuery({
    queryKey: [USER_USAGE_QUERY_KEY],
    queryFn: () => UsageService.getUsage()
  });

  const organisationUsageQuery = useQuery({
    queryKey: [ORGANISATION_USAGE_QUERY_KEY],
    queryFn: () => (shouldGetOrganisationUsage ? OrganisationService.getOrganisationUsage() : null)
  });

  if (usageQuery.isLoading || organisationUsageQuery.isLoading) return <FullScreenLoader />;
  if (usageQuery.isError || !usageQuery.data || organisationUsageQuery.isError) return <ErrorAlert />;

  return (
    <>
      <SettingsSectionWrapper title={t('USAGE.TITLE')} maw={900}>
        <UsageSummary usage={usageQuery.data} />
      </SettingsSectionWrapper>

      {organisationUsageQuery.data && (
        <>
          <Space h={40} />
          <SettingsSectionWrapper title={t('USAGE.ORGANISATION_TITLE')} icon={<IconBuildingSkyscraper />} maw={900}>
            <OrganisationUsageSummary usage={organisationUsageQuery.data} />
          </SettingsSectionWrapper>
        </>
      )}
    </>
  );
}
